import type { HandoffEntry } from './supabase.types';
import { formatRelativeDate } from '../utils/dateUtils';

/** Who wrote a go-ahead note, for HandoffEntry.by. */
export function handoffAuthor(user: { name?: string | null; email?: string | null } | null | undefined): string | null {
  return user ? user.name || user.email || null : null;
}

const STEP_LABEL: Record<HandoffEntry['step'], string> = {
  spec_approved: 'with the spec approval',
  build_approved: 'with the build approval',
};

/** "Kyle Rutten · with the spec approval · 5 minutes ago" (any part may be missing). */
export function handoffByline(entry: HandoffEntry): string {
  return [entry.by, STEP_LABEL[entry.step], entry.at ? formatRelativeDate(entry.at) : null].filter(Boolean).join(' · ');
}

/** Every note a job carries, oldest first, defensively (older rows or bad data read as none). */
export function handoffEntries(job: { handoff_notes?: HandoffEntry[] | null }): HandoffEntry[] {
  return Array.isArray(job.handoff_notes) ? job.handoff_notes.filter((e) => e && typeof e.note === 'string' && e.note.trim()) : [];
}

/** All notes as one tooltip. */
export function handoffTooltip(job: { handoff_notes?: HandoffEntry[] | null }): string {
  return handoffEntries(job)
    .map((e) => `${handoffByline(e)}\n${e.note}`)
    .join('\n\n');
}
